import type { ReactNode } from 'react'

import Loader from 'components/Loader'

import classes from './styles.module.scss'

type Props = {
  isLoading: boolean
  totalCount: number
  items: ReactNode
  noContent: ReactNode
}

export default function ContentBlock({ isLoading, totalCount, items, noContent }: Props) {
  const getContent = () => {
    if (isLoading) {
      return <Loader size={30} className={classes.loader} />
    }

    if (totalCount) {
      return items
    }

    return <div className={classes.noContent}>{noContent}</div>
  }

  return <div className={classes.root}>{getContent()}</div>
}
